var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGemPrfLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 35,
    viewBox: "0 0 117 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3014 0L0 9.72212H11.0847L5.3014 0Z",
    fill: "#C3C3C3",
    fillOpacity: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7623 0L14.4609 9.72212H25.5457L19.7623 0Z",
    fill: "#373163"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2155 0L28.9141 9.72212H39.9988L34.2155 0Z",
    fill: "#373163"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4694 12.6395L22.168 22.3616H33.2527L27.4694 12.6395Z",
    fill: "#373163"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6986 22.3608L40 12.6387L28.9153 12.6387L34.6986 22.3608Z",
    fill: "#373163"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2455 22.3608L25.5469 12.6387L14.4621 12.6387L20.2455 22.3608Z",
    fill: "#373163"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5306 9.72253L17.832 0.000414848L6.74729 0.000414848L12.5306 9.72253Z",
    fill: "#373163"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9916 9.72253L32.293 0.000414848L21.2082 0.000414848L26.9916 9.72253Z",
    fill: "#373163"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78845 22.3608L11.0898 12.6387L0.00510311 12.6387L5.78845 22.3608Z",
    fill: "#C3C3C3",
    fillOpacity: 0.32
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4955 34.9991L18.7969 25.277H7.71213L13.4955 34.9991Z",
    fill: "#373163"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9564 34.9991L33.2578 25.277H22.1731L27.9564 34.9991Z",
    fill: "#C3C3C3",
    fillOpacity: 0.32
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0123 12.6395L7.71094 22.3616H18.7957L13.0123 12.6395Z",
    fill: "#373163"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7194 25.278L15.418 35.0001H26.5027L20.7194 25.278Z",
    fill: "#C3C3C3",
    fillOpacity: 0.32
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47 4V8.9806H61.6672L63.4273 10.6408V15.068L61.6672 16.7282H47V30.0098H51.6935V21.1554H62.8406L68.1208 16.7282V8.9806L62.8406 4H47Z",
    fill: "#373163"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1484 9.17021V4H87.8193L94.043 9.17021V17.2128L87.8193 21.8085L95.4717 30.6882H88.5108L81.3792 21.8085H74.6806V31H69.1484V17.2128H86.4363L88.5108 15.4894V10.8936L86.4363 9.17021H69.1484Z",
    fill: "#827497"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.001 4H96.5V9.56304H117.001V4Z",
    fill: "#373163"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M115.83 15.1261H96.5V30.7026H102.357V20.6891H115.83V15.1261Z",
    fill: "#373163"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemPrfLogo);
export default __webpack_public_path__ + "static/media/GemPrfLogo.9c0ea39340f431540bdea9cf0d162c6e.svg";
export { ForwardRef as ReactComponent };